<template>
  <div class="section-title">
    <div class="section-title__title">
      {{ title }}
    </div>
    <div v-if="!hideMore" class="section-title__more" @click="doMoreAction">
      <span class="section-title__more--text">{{ moreText }}</span>
      <img class="section-title__more--arrow" src="../assets/img/arrow-1.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    title: {
      type: String,
      default: '標題',
    },
    moreText: {
      type: String,
      default: '更多',
    },
    moreLink: {
      type: String,
      default: 'newspage',
    },
    hideMore: {
      type: Boolean,
      default: false,
    },
    brands: {},
  },
  methods: {
    doMoreAction() {
      this.$router.push({
        name: this.moreLink,
        params: { brandsList: this.brands }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  //margin-bottom: 10px;

  &__title {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.56px;
    color: #1da7fc;
  }

  &__more {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &--text {
      margin: 0 4px 0 0;
      //margin-right: 4px;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: rgba(0, 0, 0, 0.5);
    }

    &--arrow {
      width: 4px;
      height: 8px;
    }
  }
}
</style>
